import type { StoreRootState } from "..";

export const municipalityStateSelector = (state: StoreRootState) =>
  state.municipality;

export const activeMunicipalityIdSelector = (state: StoreRootState) =>
  state.municipality.activeId;

const municipalitySelector = (state: StoreRootState) =>
  state.municipality.data ?? [];

export default municipalitySelector;
